import SubscriptionManagement from "./SubscriptionManagement";

/**
 * Rota autenticada /subscription/billing. Renderiza a tela de GESTÃO da
 * assinatura ("Plano e cobrança") dentro do AppLayout (sidebar global vem do
 * layout). Destino primário de "minha assinatura". A grade de planos vive em
 * /subscription/plans (PlansGridPage); a venda pública vive na home de marketing.
 */
const PricingPage = () => <SubscriptionManagement />;

export default PricingPage;
